import React, { Component } from 'react'
import SearchFormHome from './search-form-home'
import Weather from './weather'
import { DropDown } from './icons'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import MobileDesktopVideo from './mobile-desktop-video'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'

class HeroBanner extends Component {

  state = {
    mobileSearch: false,
    propertyType: 'residential',
  }

  render() {

    let { backgroundImage, mobileImage, title, video, mobileVideo } = this.props
    let { mobileSearch, propertyType } = this.state

    return (
      <section className='hero-banner'>

        { video && mobileVideo &&
          <MobileDesktopVideo video={video} mobileVideo={mobileVideo} />
        }
        { (!video && !mobileVideo) &&
          <>
            { mobileImage?.sourceUrl && <img className='hero-banner__bg hero-banner__bg--mobile' loading='lazy' src={mobileImage?.sourceUrl} alt={mobileImage?.altText} /> }
            { backgroundImage?.sourceUrl && <img className='hero-banner__bg hero-banner__bg--desktop' loading='lazy' src={backgroundImage?.sourceUrl} alt={backgroundImage?.altText} /> }
          </>
        }

        <div className='hero-banner__inner'>

          <div className='hero-banner__content'>
            <div className='hero-banner__menu'>
              <Fade top distance='40px' duration={1000} delay={1200}>
                <ul>
                  <li className={`${propertyType === 'residential' ? 'active' : ''}`}><button type='button' onClick={() => this.setState({ propertyType: 'residential' })}>Residential</button></li>
                  <li className={`${propertyType === 'commercial' ? 'active' : ''}`}><button type='button' onClick={() => this.setState({ propertyType: 'commercial' })}>Commercial</button></li>
                  <li className={`${propertyType === 'projects' ? 'active' : ''}`}><Link to='/projects/'>New Projects</Link></li>
                </ul>
              </Fade>
            </div>
            <Fade bottom distance='40px' duration={1000}>
              <div className='hero-banner__heading'>
                <h1>{ title }</h1>
              </div>
            </Fade>

            <Fade bottom distance='40px' duration={1000} delay={1200}>
              <div className={`hero-banner__search ${mobileSearch && 'active'}`}>
                <SearchFormHome propertyType={propertyType} />
                <button
                  type='button'
                  className={`hero-banner__mobile-toggle ${mobileSearch && 'active'}`}
                  onClick={() => this.setState({ mobileSearch: true })}
                >
                  Advanced Search
                  <DropDown color={'#FFFFFF'} />
                </button>
              </div>

              <div className='hero-banner__menu hero-banner__menu--mobile'>
                <ul>
                  <li className={`${propertyType === 'residential' ? 'active' : ''}`}><button type='button' onClick={() => this.setState({ propertyType: 'residential' })}>Residential</button></li>
                  <li className={`${propertyType === 'commercial' ? 'active' : ''}`}><button type='button' onClick={() => this.setState({ propertyType: 'commercial' })}>Commercial</button></li>
                  <li className={`${propertyType === 'projects' ? 'active' : ''}`}><button type='button' onClick={() => this.setState({ propertyType: 'projects' })}>New Projects</button></li>
                </ul>
              </div>

              <div className='hero-banner__weather hero-banner__weather--desktop'>
                <Weather />
              </div>
            </Fade>
          </div>

            <div className='hero-banner__weather hero-banner__weather--mobile'>
              <Fade bottom distance='40px' duration={1000} delay={2000}>
                <Weather />
              </Fade>
            </div>

        </div>
      </section>
    )
  }
}

export default HeroBanner
